import { Flex, Space, Text, Title } from '@mantine/core';
import { useNavigate } from '@tanstack/react-router';

import { LBButton } from '@/shared/ui-kit/components';
import { Logo } from '@/shared/ui-kit/icons/Logo';

export const ErrorPage = () => {
  const navigate = useNavigate();
  return (
    <div
      style={{
        height: '80vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Space h={45} />
      <Flex align='center' justify='center'>
        <Logo
          style={{
            color: 'var(--mantine-primary-color)'
          }}
        />
      </Flex>
      <Space h={48} />
      <Flex
        align='center'
        bg='white'
        direction='column'
        justify='center'
        style={{
          padding: 20,
          paddingTop: 40,
          borderRadius: 16
        }}
      >
        <Title c='red'>Ошибка 404</Title>
        <Space h={16} />
        <Title order={3}>Страница не найдена</Title>
        <Space h={8} />
        <Text fz={14} ta='center'>
          Мы сожалеем, но страницы не существует. Пожалуйста, перейдите на
          главную.
        </Text>
        <Space h={32} />
        <LBButton
          fullWidth
          onClick={() => {
            navigate({ to: '/' });
          }}
        >
          На главную
        </LBButton>
      </Flex>
    </div>
  );
};
